import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Avatar from './Avatar';

interface AvatarTooltipProps {
  name: string;
  url?: string;
  size?: 'sm' | 'md' | 'lg';
}

const AvatarTooltip: React.FC<AvatarTooltipProps> = ({ name, url, size = 'md' }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Avatar name={name} url={url} size={size} />
      
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className="absolute left-0 bottom-full -translate-x-5 mb-2 px-3 py-1.5 bg-background border rounded-md shadow-md whitespace-nowrap z-50"
            style={{ 
              transformOrigin: 'center bottom',
              willChange: 'transform'
            }}
          >
            <div className="text-sm font-medium text-gray-350">{name}</div>
          
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AvatarTooltip;